<template>
    <div class="con">
        <div class="banner">
            <img v-if="select==0" src="../assets/zy/pbanner.png" alt="">
            <img src="../assets/zy/pbanner2.png" alt="" v-if="select==1">
        </div>
        <div class="banner2">
            <img v-if="select==0" src="../assets/zy/pbanner.png" alt="">
            <img src="../assets/zy/pbanner22.png" alt="" v-if="select==1">
        </div>
            <div class="main" >
                <div class="navList wow fadeInUp">
                    <div class="item" v-for="(item,index) in $t('pro').navList" :key="index" :class="{active:select===index}" @click="change(index)">
                        {{item}}
                    </div>
                </div>

                <transition name="fade">
                    <div class="products" v-if="select===0">
                        <div class="lList wow fadeInLeft">
                            <p class="title">{{$t('pro').text0}}</p>
                            <div class="tList">
                                <el-tree
                                        :data="data"
                                        :props="defaultProps"
                                        node-key="id"
                                        accordion
                                        @current-change="handleNodeClick"
                                        >
                                     <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-button
                  type="text"
                  size="mini"
                  @click="() => append(data)">
             <i class="el-icon-plus"></i>
          </el-button>
        </span>
      </span>
                                </el-tree>
                            </div>
                            <div class="search">
                                <input type="text" placeholder="Search" v-model="keywords">
                                <i class="iconfont icon-sousuo" @click="gotoSearch"></i>
                            </div>
                        </div>
                        <div class="mInfo wow">
                         <div class="allItems">
                             <div class="item" v-for="(item,index) in pList" :key="index" @click="gotoProList(item.id)">
                                 <div class="one">
                                     <img :src="`https://dhkbearing.net/${item.picurl}`" alt="">
                                 </div>
                                 <div class="two">
                                    <p>
                                        {{item.classname}}
                                        <i class="iconfont icon-jiantou"></i>
                                    </p>
                                     <p>
                                         <i class="el-icon-caret-right"></i>
                                         {{item.description}}
                                     </p>
                                 </div>
                             </div>
                         </div>
                        </div>
<!--                        <div class="btn wow fadeInUp">-->
<!--                            查看更多-->
<!--                        </div>-->
                    </div>
                </transition>


                <transition name="fade">
                    <div class="solution" v-if="select===1">
                      <div class="allItems">
                           <div class="item" v-for="(item,index) in sList" :key="index" @click="gotosInfo(item.id)">
                               <div class="one">
                                   <img :src="`https://dhkbearing.net/${item.picurl}`" alt="">
                               </div>
                               <div class="two">
                                    <p>
                                        {{item.title}}
                                        <i class="iconfont icon-jiantou"></i>
                                    </p>
                                   <p>{{item.description}}</p>
                               </div>
                           </div>
                      </div>
                    </div>
                </transition>
            </div>
        <foot-Component class="wow fadeIn"></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import Scrollbar from 'smooth-scrollbar'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import {getClass2,getClass,getProductList,getProductsUrl,getProductInfo,getClass2_en} from '../util/lang'
    export default {
        name: 'pro',
        data(){
            return{
                keywords:'',
                select:0,
                navList:[
                    "产品中心",
                    "行业解决方案"
                ],
                pList:[],
                sList:[],
                data: [
                    // {
                    //     label: '深沟球轴承',
                    //     id:"0",
                    //     children: [
                    //     {label: '单列深沟球轴承',id:"11"},
                    //     {label: '双列深沟球轴承'}
                    // ]},
                    // {
                    //     label: '深沟球轴承',
                    //     id:"1"
                    // }
                ],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            }
        },
        components:{footComponent, swiper, swiperSlide},
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            this.scrollbar.addListener((status) => {
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.getSolution('121')
                    this.getNav('122')
                    this.getNav2_en()
                }else{
                    this.getSolution('21')
                    this.getNav('22')
                    this.getNav2()
                }
            })
          if(window.location.search.replace('?', '').split('=')[1]!==undefined){
              this.setIndex(parseInt(this.getNid()))
              // this.getList(parseInt(this.getNid()))
          }else{
              // this.getList('5')
          }
        },
        methods:{
            append(data) {
                if(data.isLast===true){
                    const  link=`/pro2.html?id=${data.id}`
                    window.open(link,'_self')
                }else{
                    const  link=`/proList.html?id=${data.id}`
                    window.open(link,'_self')
                }

               // console.log(data.id)
            },
            gotoSearch(){
                const  link=`/proSearch.html?keywords=${this.keywords}`
                window.open(link,'_blank')
                this.keywords=''
            },
            handleNodeClick(data) {
                if(data.isShow===true){
                    if(data.children===undefined){
                        const  link=`/proInfo2.html?id=${data.id}`
                        window.open(link,'_self')
                    }
                }else{
                    if(data.children===undefined){
                        const  link=`/proInfo.html?id=${data.id}`
                        window.open(link,'_self')
                    }
                }
            },
            getList(id){
                this.id=id
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                })
            },
            getSolution(id){
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.sList=res.data.data
                })
            },
            gotosInfo(id){
                const  link=`/solutionInfo.html?id=${id}`
                window.open(link,'_self')
            },
            gotoProList(id){
                if(id==28){
                    const  link=`/pro2.html?id=${id}`
                    window.open(link,'_self')
                }else{
                    const  link=`/proList.html?id=${id}`
                    window.open(link,'_self')
                }
            },
            getInfo(n){
                const url = `${getProductInfo('ProductPage',n)}`
                this.$axios.get(url).then(res => {
                    this.info=res.data
                })
            },
            getNid () {
                return window.location.search.replace('?', '').split('=')[1].split('?')[0]
            },
            setIndex(n){
                this.select=n
            },
            getNav(id){
                const url = `${getClass(id)}`
                this.$axios.get(url).then(res => {
                    this.pList=res.data.data
                })
            },
            getNav2(){
                const url = `${getClass2(0)}`
                this.$axios.get(url).then(res => {
                    res.data.other.map((item)=>{
                        item.children.map((i)=>{
                            i.isShow=true
                        })
                    })
                    res.data.other_class.isLast=true
                    res.data.other_class.children=res.data.other
                    this.data=res.data.data.concat(res.data.other_class)
                })
            },
            getNav2_en(){
                const url = `${getClass2_en(0)}`
                this.$axios.get(url).then(res => {
                    res.data.other.map((item)=>{
                        item.children.map((i)=>{
                            i.isShow=true
                        })
                    })
                    res.data.other_class.isLast=true
                    res.data.other_class.children=res.data.other
                    this.data=res.data.data.concat(res.data.other_class)
                })
            },
            change(n) {
      let link;
      if(2 === n){
        console.log(n)
        link = `http://products.dhkbearing.net`;
      }else{
        link = `/products.html?index=${n}`;
      }
      window.open(link, "_self");
    }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        overflow: hidden;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            display: block;
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
        }
        .banner2{
            display: none;
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
        }
        .main{
            .navList{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                box-shadow:0px 9px 42px 9px rgba(0, 0, 0, 0.03);
                .item{
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                    font-weight: lighter;
                    cursor: pointer;
                    transition: 0.3s;
                    position: relative;
                    padding:5px 50px;
                    color:#333333;
                    font-size: 14px;
                    height: 50px;
                    line-height: 50px;
                    display: block;
                    z-index: 1;
                    font-family: "SOURCEHANSANSCN-LIGHT.OTF";
                    &::before{
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 100%;
                        background-color:#FECE4A;
                        transform-origin: 100%;
                        -webkit-transform-origin: 100%;
                        -webkit-transition: -webkit-transform .5s cubic-bezier(.4,0,.2,1);
                        transition: transform .5s cubic-bezier(.4,0,.2,1);
                        transform: scaleX(0);
                        -webkit-transform: scaleX(0);
                        visibility: hidden\9;
                        z-index: -1;
                    }
                    &:hover{
                        color:white;
                    }
                    &:hover::before{
                        transform: scaleX(1);
                        -webkit-transform: scaleX(1);
                        -moz-transform: scaleX(1);
                        transform-origin: 0;
                        -webkit-transform-origin: 0;
                        visibility: visible\9;
                    }
                }
                .active{
                    color:white;
                }
                .active::before{
                    transform: scaleX(1);
                    -webkit-transform: scaleX(1);
                    -moz-transform: scaleX(1);
                    transform-origin: 0;
                    -webkit-transform-origin: 0;
                    visibility: visible\9;
                }
            }
            .products{
                width:1440px;
                margin: 60px auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                .lList{
                    width:20%;
                    .title{
                        color:#333333;
                        font-family: "SourceHanSansSC-Medium";
                        font-size: 20px;
                        border-bottom: 1px solid #DCDCDC;
                        padding: 30px 0;
                    }
                    .tList{
                        width:100%;
                        margin: 30px auto;
                    }
                    .search{
                        width:100%;
                        position: relative;
                        margin: 30px auto;
                        margin-top: 60px;
                        input{
                            width:100%;
                            background-color: #F3F3F3;
                            height:35px;
                            border: none;
                            text-indent: 10px;
                        }
                        i{
                            position: absolute;
                            right:10px;
                            top:10px;
                            color:black;
                            cursor: pointer;
                        }
                    }
                }
                .mInfo{
                    width:75%;
                    animation:polygon 1s  forwards linear  ;
                    .allItems{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        margin-left: -4%;
                        .item{
                            width:28%;
                            margin-top: 60px;
                            margin-left: 4%;
                            cursor: pointer;
                            .one{
                                width:100%;
                                text-align: center;
                                padding: 30px 0;
                                border-bottom: 1px solid #AEAEAE;
                                position: relative;
                                img{
                                    transition: all 600ms;
                                    width:100%;
                                    display: block;
                                    object-fit: cover;
                                    height:214px;
                                }
                                &::after{
                                    content:'';
                                    display: inline-block;
                                    height:3px;
                                    width:0;
                                    background-color: #FECD4A;
                                    bottom:-1px;
                                    left:0;
                                    transition: all 600ms;
                                    position: absolute;
                                }
                            }
                            .two{
                                width:95%;
                                margin: 20px auto;
                                p:nth-child(1){
                                    color:#585858;
                                    font-family: "SOURCEHANSANSCN-HEAVY";
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    transition: all 600ms;
                                    font-size: 20px;
                                    i{
                                        font-size: 20px;
                                    }
                                }
                                p:nth-child(2){
                                    display: flex;
                                    flex-direction: row;
                                    margin: 20px 0;
                                    color:#666666;
                                    font-family: "SOURCEHANSANSCN-LIGHT";
                                    line-height: 27px;
                                    font-size: 15px;
                                    position: relative;
                                    padding-left: 20px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    overflow: hidden;
                                    height:54px;
                                    i{
                                        display: inline-block;
                                        position: absolute;
                                        left:0;
                                        top:5px;
                                    }
                                }
                            }
                            &:hover{
                                .one{
                                    img{
                                        transform: scale(1.05);
                                    }
                                    &::after{
                                        width:100%;
                                    }
                                }
                                .two{
                                    p:nth-child(1){
                                        color:#FECD4A;
                                    }
                                }
                            }
                        }
                    }
                }
                .btn{
                    width:160px;
                    height:50px;
                    background:#F6C02E;
                    border-radius:15px;
                    text-align: center;
                    line-height: 50px;
                    color:white;
                    font-family: "SOURCEHANSANSCN-LIGHT";
                    cursor: pointer;
                    transition: all 600ms;
                    margin: 60px auto;
                    &:hover{
                        box-shadow:6px 8px 38px 0px rgba(155,124,43,0.5);
                    }
                }
            }
            .solution{
                width:1100px;
                margin: 60px auto;
                .allItems{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin-left: -3%;
                    .item{
                        width:28%;
                        margin-left: 3%;
                        cursor: pointer;
                        border:1px solid rgba(174,174,174,.2);
                        margin-top: 40px;
                        .one{
                            width:100%;
                            overflow: hidden;
                            img{
                                width:100%;
                                display: block;
                                object-fit: cover;
                                transition: all 600ms;
                            }
                        }
                        .two{
                            width:80%;
                            margin: 20px auto;
                            p{
                                margin: 20px auto;
                            }
                            p:nth-child(1){
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                color:#585858;
                                transition: all 600ms;
                                font-family: "SOURCEHANSANSCN-HEAVY";
                                i{
                                    font-size: 20px;
                                }
                            }
                            p:nth-child(2){
                                color:#666666;
                                font-family: "SOURCEHANSANSCN-LIGHT";
                                line-height: 20px;
                                font-size: 14px;
                            }
                        }
                        &:hover{
                            .one{
                                img{
                                    transform: scale(1.05);
                                }
                            }
                            .two{
                                p:nth-child(1){
                                    color:#F6C02E;
                                }
                            }
                        }
                    }
                }
            }
        }
        .foot{
            animation-duration: 2s;
        }
        @keyframes left1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes right1 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(0 0,0 100%,0 100%,0 0);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1440px){
            .main{
            width:100%;
            .navList {
        .item{
          padding: 5px 9px;
        }
      }
                .products{
                    width:90%;
                }
                .title,.allItems,.title2,.html{
                    width:90%;
                }
                .allItems{
                    flex-direction: column;
                    .item{
                        width:100%;
                        margin-left: 0;
                        margin-top: 30px;
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                display: none;
            }
            .banner2{
                display: block;
                img{
                    height:500px;
                }
                .text{
                    bottom:20%;
                    p:nth-child(1){
                        font-size: 30px;
                    }
                    p:nth-child(2){
                        font-size: 16px;
                    }
                }
            }
            .main{
                .navList{
                    .item{
                        width:33.3%;
                        padding: 5px 0;
                        text-align: center;
                        font-size: 12px;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                }
                .products{
                    width:90%;
                    flex-direction: column;
                    .lList,.mInfo{
                        width:100%;
                        margin-left: 0;
                    }
                    .mInfo{
                        .allItems{
                            margin-left: 0;
                            .item{
                                width:100%;
                                margin-left: 0;
                            }
                        }
                    }
                }
                .solution{
                    width:90%;
                    .allItems{
                        margin-left: 0;
                        .item{
                            margin-left: 0;
                            width:100%;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
    .proList2 .swiper-pagination>>>.swiper-pagination-bullet {
        width:5px;
        height:5px;
        background:rgba(83,83,83,1);
        border-radius:50%;
        margin-left: 30px;
        position: relative;
    }
    .proList2 .swiper-pagination>>>.swiper-pagination-bullet::before{
        content:'';
        width:15px;
        height:15px;
        border:1px solid rgba(83,83,83,1);
        border-radius:50%;
        display: inline-block;
        position: absolute;
        left:-6px;
        top:-6px;
        opacity: 0;
        transition: all 600ms;
    }
    .proList2 .swiper-pagination>>>.swiper-pagination-bullet-active::before{
        opacity: 1;
    }
</style>
